import {
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { useFormContext } from 'react-hook-form';

interface TextFieldProps {
	name: string;
	label?: string;
	description?: string;
	placeholder?: string;
	className?: string;
}

export function GroupPricingTextField({
	name,
	description,
	placeholder,
	className,
}: TextFieldProps) {
	const form = useFormContext();

	return (
		<div className={className ?? 'tw-space-y-2'}>
			<FormField
				control={form.control}
				name={name}
				render={({ field }) => (
					<FormItem>
						<FormControl>
							<Input
								className='tw-bg-white hover:tw-bg-secondary'
								placeholder={placeholder}
								{...field}
							/>
						</FormControl>
						<FormDescription>{description}</FormDescription>
						<FormMessage />
					</FormItem>
				)}
			/>
		</div>
	);
}
